/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_Scan_InstructionInputs */



/**
* | output |
* | --- |
* | "Scan with your phone camera to check in" |
*
* @param {Checkin_Qr_Scan_InstructionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_scan_instruction = /** @type {((inputs?: Checkin_Qr_Scan_InstructionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_Scan_InstructionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scannez avec la caméra de votre téléphone pour pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escanea con la cámara de tu teléfono para hacer check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escaneie com a câmera do seu celular para fazer check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansiona con la fotocamera del telefono per fare il check-in")
	return /** @type {LocalizedString} */ ("Scan with your phone camera to check in")
});